import React from 'react';
import { CalendarCheck, Clock, MapPin, NavigationArrow } from '@phosphor-icons/react';
import { format } from 'date-fns';

export const PlanningWidget = ({ wrapStyle, weekDays, getTasksForDay, openNavigation, dateFnsLocale, language }) => (
  <div style={wrapStyle}>
    <div className="card">
      <div className="card-header">
        <h3 className="card-title" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <CalendarCheck size={20} /> {language === 'en' ? 'This week planning' : 'Planning de la semaine'}
        </h3>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, minmax(140px, 1fr))', gap: '1px', backgroundColor: '#E2E2E6', border: '1px solid #E2E2E6' }}>
          {weekDays.map((day) => {
            const isToday = format(day, 'yyyy-MM-dd') === format(new Date(), 'yyyy-MM-dd');
            const dayTasks = getTasksForDay(day);
            return (
              <div key={day.toISOString()} style={{ backgroundColor: 'white', minHeight: '150px' }}>
                <div style={{ padding: '12px', borderBottom: '1px solid #E2E2E6', backgroundColor: isToday ? 'var(--primary, #002FA7)' : '#F4F5F7', color: isToday ? 'white' : '#0A0B10', textAlign: 'center' }}>
                  <div style={{ fontWeight: '600', fontSize: '0.875rem' }}>{format(day, 'EEEE', { locale: dateFnsLocale })}</div>
                  <div style={{ fontSize: '0.75rem', opacity: 0.8 }}>{format(day, 'dd/MM')}</div>
                </div>
                <div style={{ padding: '8px' }}>
                  {dayTasks.length > 0 ? dayTasks.map(task => (
                    <div key={task.id} style={{ backgroundColor: '#E8F5E9', border: '1px solid #A5D6A7', borderRadius: '4px', padding: '10px', marginBottom: '8px', fontSize: '0.8rem' }}>
                      <div style={{ fontWeight: '600', marginBottom: '6px', color: '#2E7D32' }}>{task.title}</div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px', color: '#5E5F66', marginBottom: '4px' }}><Clock size={14} /> {task.start_time} - {task.end_time}</div>
                      {task.address && (
                        <>
                          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '4px', color: '#5E5F66', fontSize: '0.75rem', marginBottom: '8px' }}>
                            <MapPin size={14} style={{ flexShrink: 0, marginTop: '2px' }} />
                            <span style={{ overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>{task.address}</span>
                          </div>
                          <button data-testid={`navigate-task-${task.id}`} className="btn btn-primary btn-sm" style={{ width: '100%', padding: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', fontSize: '0.75rem' }} onClick={() => openNavigation(task.address)}>
                            <NavigationArrow size={16} weight="fill" /> {language === 'en' ? 'Navigate' : 'Guider vers le chantier'}
                          </button>
                        </>
                      )}
                      {task.description && <div style={{ fontSize: '0.7rem', color: '#5E5F66', marginTop: '6px', fontStyle: 'italic' }}>{task.description}</div>}
                    </div>
                  )) : (
                    <div style={{ textAlign: 'center', color: '#9E9E9E', fontSize: '0.75rem', padding: '20px 0' }}>{language === 'en' ? 'No tasks' : 'Aucune tache'}</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </div>
);
